import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {clarityService} from '../services/clarity/clarityService';

export const useClarityRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page navigation whenever the route changes
    if (clarityService.initialized) {
      clarityService.trackPageNavigation(location.pathname + location.search);
    }
  }, [location.pathname, location.search]);

  return null;
}; 